var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgKeshetApproved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.94677 13.2137H1V11.5043H2.11527V8.97356C2.11527 8.74713 2.20274 8.52997 2.35845 8.36986C2.51415 8.20975 2.72533 8.1198 2.94553 8.1198H8.54605V9.82732H3.77517V12.3599C3.77517 12.586 3.68795 12.8029 3.53265 12.9629C3.37735 13.123 3.16664 13.2132 2.94677 13.2137Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4691 8H10.8086V12.9543H12.4691V8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9466 11.264H18.2861V16.3636H19.9466V11.264Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9999 12.9531H22.3394V9.82732H14.9253V8.1198H23.1696C23.3898 8.1198 23.601 8.20975 23.7567 8.36986C23.9124 8.52997 23.9999 8.74713 23.9999 8.97356V12.9531Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7063 16.1241H7.66082C7.44063 16.1241 7.22945 16.0341 7.07374 15.874C6.91804 15.7139 6.83057 15.4967 6.83057 15.2703V11.264H8.49108V14.4166H14.8791V11.264H16.5396V15.2703C16.5396 15.3827 16.518 15.494 16.4761 15.5978C16.4342 15.7016 16.3728 15.7958 16.2954 15.8751C16.2179 15.9545 16.126 16.0173 16.0249 16.06C15.9239 16.1027 15.8156 16.1245 15.7063 16.1241Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 8.36364,
    fill: "white",
    transform: "translate(1 8)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeshetApproved);
export default __webpack_public_path__ + "static/media/keshetApproved.c699abf373dc9d31cfe0d69f1975dbb1.svg";
export { ForwardRef as ReactComponent };